import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { usePageWarning } from 'components/modules/Insurance/hooks/usePageWarnings';
import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';
import { getVehicleInformation } from 'store/insurance/actions';
import { selectPageLoading } from 'store/insurance/selectors';

import { useDisabledFields } from './hooks/useDisabledFields';
import { useFieldsControl } from './hooks/useFieldsControl';
import { useSubmit } from './hooks/useSubmit';

const { ROUTES, ROUTE_NAMES } = Insurance;

export const useVehicleInformationPresenter = () => {
  const dispatch = useDispatch();

  const loading = useSelector(selectPageLoading(ROUTE_NAMES.VEHICLE_INFORMATION));

  const warnings = usePageWarning();
  const { params } = useRouteMatch({ routes: ROUTES }) ?? {};
  const { disabled: pageRestrict } = useDisabledFields();
  const { onSubmit } = useSubmit();

  const { id: worksheetId } = params ?? {};

  useFieldsControl();

  useEffect(() => {
    dispatch(getVehicleInformation(worksheetId));
  }, [worksheetId]);

  return { disabled: pageRestrict, loading, onSubmit, warnings };
};
